export const phoneReg = /^1[0-9]{10}$/
export const idCardReg = /^[\dA-Za-z]+$/;
export const passwordReg = /^\d{6}$/;



// WEBPACK FOOTER //
// ./src/config/regular.js